// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__pXf9g","itemTitle":"ClientEmergencyInfo_itemTitle__1fxTX","itemText":"ClientEmergencyInfo_itemText__2STGd"};